import React, { useCallback } from "react";
import { ListChecks } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { getNextQueryParams } from "components/helpers";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import withRoleCheck from "components/hocs/withRoleCheck";
import CampaignStatusPresetService from "services/CampaignStatusPreset";
import {
  useCampaignStatusPresetsTable,
  invalidateCampaignStatusPresetsTableQuery,
} from "hooks/useCampaignStatusPresetsTable";
import CampaignStatusPresetModal from "routes/campaign_status_presets/components/CampaignStatusPresetModal";

export const CAMPAIGN_STATUS_PRESETS_TABLE_CONSTANTS = {
  tableName: "campaign_status_presets",
  queryKey: "campaign_status_preset",
  className: "CampaignStatusPreset",
  header: "Campaign Status Presets",
  headerIcon: ListChecks,
};

const NewCampaignStatusPresetModal = withRoleCheck(CampaignStatusPresetModal, [
  ACL_RELATIONSHIPS.campaignStatusPreset.create,
  ACL_RELATIONSHIPS.campaignStatuses.read,
]);

const CampaignStatusPresetsTableV3 = () => {
  const { filters, columns } = useCampaignStatusPresetsTable({
    tableName: CAMPAIGN_STATUS_PRESETS_TABLE_CONSTANTS.tableName,
  });

  const fetchPresets = useCallback(
    async queryParams => {
      const nextQueryParams = getNextQueryParams(queryParams, columns);
      const response =
        await CampaignStatusPresetService.getCampaignStatusPresetsAsTable(
          nextQueryParams
        );
      return response;
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      headerIcon={CAMPAIGN_STATUS_PRESETS_TABLE_CONSTANTS.headerIcon}
      header={CAMPAIGN_STATUS_PRESETS_TABLE_CONSTANTS.header}
      tableName={CAMPAIGN_STATUS_PRESETS_TABLE_CONSTANTS.tableName}
      queryKey={CAMPAIGN_STATUS_PRESETS_TABLE_CONSTANTS.queryKey}
      fetchData={fetchPresets}
      createButton={
        <NewCampaignStatusPresetModal
          fetchPresets={invalidateCampaignStatusPresetsTableQuery}
        />
      }
      enableSearch
      enableSettings
      invalidateData={invalidateCampaignStatusPresetsTableQuery}
    />
  );
};

export default CampaignStatusPresetsTableV3;
